'use client';

import { useEffect } from 'react';
import { toast } from 'sonner';

/**
 * Faza J — Service Worker registration + update notification.
 *
 * - Register `/sw.js` la mount
 * - Detect when SW activates a new version (controllerchange) → notify user
 * - User initiates reload manually (no forced refresh mid-session)
 *
 * Note: only runs in production (dev SW interferes cu HMR).
 */
export function SwRegister() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    // Skip în dev — Next.js HMR conflict
    if (process.env.NODE_ENV !== 'production') return;

    const register = async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });

        // Listen for new SW activation → notify user there's an update available
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New SW installed but waiting; tell user
              toast('Versiune nouă disponibilă', {
                description: 'Reîncarcă pagina pentru a o folosi.',
                duration: 30000,
                action: {
                  label: 'Reîncarcă',
                  onClick: () => window.location.reload(),
                },
              });
            }
          });
        });

        // Periodic check for updates (every 30 min while tab open)
        setInterval(() => registration.update().catch(() => {}), 30 * 60 * 1000);
      } catch (err) {
        // Silent fail — SW e nice-to-have, nu break aplicația
        console.warn('[SW] Registration failed:', err);
      }
    };

    register();
  }, []);

  return null;
}
